module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.a613e81.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/roboto/Roboto-Bold.otf
// module id = 2RKI
// module chunks = 0